// razorpay functions for adding addon/top up and payments

import { axiosConfig } from "../../axios/axiosConfig";
import { loadScript } from "./common";
import userDetailsLocalStorage from "../userDetailsLocalStorage";

const userName = userDetailsLocalStorage?.username;
const userEmail = userDetailsLocalStorage?.email;
const userPhone = userDetailsLocalStorage?.phoneno;

// RAZORPAY CHECKOUT AND PAYMENT ORDER TO BACKEND
export async function razorpayCheckoutAddTopup(PAYMENT_OBJ) {
  const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

  if (!res) {
    alert("Razorpay SDK failed to load. Are you online?");
    return;
  }

  const { customer_id, payment_mode, topup_price, invoice_id, userTopupID, topup_plan_id, USERID } = PAYMENT_OBJ

  try {
    const res = await axiosConfig({
      method: "post",
      url: "/payment/user_topup_payment_order",
      data: {
        userid: USERID,
        amount: topup_price,
        plan_id: topup_plan_id,
        currency: "INR",
        // paymentmode: payment_mode,
        paymentmode: "online",
      },
    });

    const paymentOrderData = res.data.response;
    // const userTopupID = res.data.response.id;
    // console.log("payment order res.data: ", res.data);

    const transaction_id = res.data.user_payment_details.id;

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      // currency: data.currency,
      currency: "INR",
      amount: paymentOrderData.amount.toString(), 
      order_id: paymentOrderData.id,
      name: "StockYaari",
      // callback_url: res.data.callback_url,
      callback_url: '/thanks-for-paying',
      description: "Thanks for paying",
      image: "",
      handler: function (response) {
        // console.log("razorpay handler res: ", response);
        // const payment_id = response.razorpay_payment_id;

        const paymentVerifyData = {
          userid: USERID,
          transaction_id: transaction_id,
          // user_topup_id: userTopupID,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          amount: topup_price,
        };

        topUpPaymentVerify(paymentVerifyData, PAYMENT_OBJ);
      },
      prefill: {
        name: userName,
        email: userEmail,
        phone_number: userPhone,
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  } catch (error) {
    console.log(error);
  }
}

// PAYMENT VERIFICATION FUNCTION FOR RAZORPAY
// below function is being used above in line 57
async function topUpPaymentVerify(payment_data, payment_object) {
  
  try {
    const res = await axiosConfig({
      method: "post",
      url: "/payment/user_topup_payment_verify",
      data: { ...payment_data, ...payment_object }
    });

    
    // IMP: UNCOMMENT IT LATER, PAYMENT SUCCESS URL.
    // window.location.replace(res.data.callback_url);
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
}
